// components/PostForm.jsx
import React, { useState, useEffect } from "react";
import { createComment, updateComment } from "../api/community";
import "../css/Form.css";

export default function CommentForm({ communityId, topicId, postId, existingComment, onSuccess, setlang }) {

  const [content, setContent] = useState(existingComment?.content || "");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (existingComment) {
      setContent(existingComment.content);
    }
  }, [existingComment]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = { content, file };
      if (existingComment) {
        await updateComment(communityId, topicId, postId, existingComment.id, data);
      } else {
        await createComment(communityId, topicId, postId, data);
      }
      if (onSuccess) onSuccess();
      setContent("");
      setFile(null);
    } catch (err) {
      //console.error("Post error:", err);
      setError(setlang==="en"?"Failed to save comment.":"مشکلی در ایجاد کامنت رخ داد، لطفا دوباره وارد شو");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="form-container" onSubmit={handleSubmit}>
      {setlang === "en" ? (
        <>
        <h2>{existingComment ? "Edit Comment" : "Create Comment"}</h2>
        {error && <p className="form-error">{error}</p>}
        </>
      ):(
        <>
        <h2>{existingComment ? "ویرایش کامنت" : "کامنت جدید"}</h2>
        {error && <p className="form-error">مشکلی در ایجاد کامنت جدید رخ داد</p>}
        </>
      )}

      <textarea
        rows="4"
        value={content}
        onChange={(e) => setContent(e.target.value)}
        required
      />

      {/*<label>Attach Images</label>
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setFile(e.target.files[0])}
      />*/}
      
      {setlang === "en" ? (
        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : existingComment ? "Update" : "Post"}
        </button>
      ):(
        <button type="submit" disabled={loading}>
          {loading ? "در حال بارگذاری ..." : existingComment ? "به‌روزرسانی" : "ارسال"}
        </button>
      )}
    </form>
  );
}
